import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './styles/Header.css';

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  // Close mobile menu when route changes
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  // Lock scroll when mobile menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="header">
      <div className="header__container">
        <div className="header__logo">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <h1>Teaming up with social artificial agents</h1>
          </Link>
          <span className="header__badge">Work in Progress</span>
        </div>

        {/* Desktop Navigation */}
        <nav className="header__nav-desktop">
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/people">People</Link></li>
            <li><Link to="/news">News</Link></li>
            <li><Link to="/publications">Publications</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </nav>

        {/* Hamburger menu for mobile */}
        <div
          className={`header__toggle ${isOpen ? 'active' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <div className="header__bar"></div>
          <div className="header__bar"></div>
          <div className="header__bar"></div>
        </div>

        {/* Mobile Navigation */}
        <nav className={`header__nav-mobile ${isOpen ? 'header__nav--open' : ''}`}>
          <ul>
            <li><Link to="/" onClick={toggleMenu}>Home</Link></li>
            <li><Link to="/about" onClick={toggleMenu}>About</Link></li>
            <li><Link to="/people" onClick={toggleMenu}>People</Link></li>
            <li><Link to="/news" onClick={toggleMenu}>News</Link></li>
            <li><Link to="/publications" onClick={toggleMenu}>Publications</Link></li>
            <li><Link to="/contact" onClick={toggleMenu}>Contact</Link></li>
          </ul>
        </nav>

        {/* Overlay for mobile menu */}
        {isOpen && (
          <div
            className={`mobile-menu-overlay ${isOpen ? 'active' : ''}`}
            onClick={toggleMenu}
          ></div>
        )}
      </div>
    </header>
  );
}

export default Header;